import { DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutEquipWarningQuickInfo extends Layout {
    labelDriverHeader: Label;
    labelLicenseCaption: Label;
    labelLicenseDate: Label;
    labelLicenseExpired: Label;
    labelMvrCaption: Label;
    labelMvrDate: Label;
    labelMvrExpired: Label;
    labelPhysicalCaption: Label;
    labelPhysicalDate: Label;
    labelPhysicalExpired: Label;
    labelTractorCaption: Label;
    labelTractorHeader: Label;
    labelTractorInspectExpired: Label;
    labelTractorInspection: Label;
    labelTrailer2Caption: Label;
    labelTrailer2InspectExpired: Label;
    labelTrailer2Inspection: Label;
    labelTrailer3Caption: Label;
    labelTrailer3InspectExpired: Label;
    labelTrailer3Inspection: Label;
    labelTrailerCaption: Label;
    labelTrailerHeader: Label;
    labelTrailerInspectExpired: Label;
    labelTrailerInspection: Label;
    panelDriverWarnings: Panel;
    panelLicense: Panel;
    panelMvr: Panel;
    panelPhysical: Panel;
    panelTractorInspection: Panel;
    panelTractorWarnings: Panel;
    panelTrailer2Inspection: Panel;
    panelTrailer3Inspection: Panel;
    panelTrailerInspection: Panel;
    panelTrailerWarnings: Panel;
    sourceEquipMove: DataSource;
}
